// Self-assessed scores from the original portfolio, on a scale from 1 to 5.
export const skills = {
  languages: [
    { name: 'JavaScript', level: 4 }, { name: 'TypeScript', level: 4 },
    { name: 'Python', level: 4 }, { name: 'Java', level: 4 },
    { name: 'C#', level: 3 }, { name: 'HTML', level: 4 }, { name: 'CSS', level: 3 },
  ],
  frameworks: [
    { name: 'React', level: 3 }, { name: 'Node.js', level: 4 },
    { name: 'FastAPI', level: 4 }, { name: 'Spring Boot', level: 2 },
    { name: '.NET Framework', level: 3 }, { name: 'Entity Framework', level: 3 },
    { name: 'JSX', level: 3 }, { name: 'Tailwind CSS', level: 4 },
    { name: 'React Native', level: 2 }, { name: 'Llama-cpp', level: 2 },
  ],
  databases: [
    { name: 'PostgreSQL', level: 3 }, { name: 'MySQL', level: 4 },
    { name: 'MS SQL Server', level: 3 }, { name: 'MongoDB', level: 2 },
    { name: 'DuckDB', level: 2 }, { name: 'SQLite', level: 2 },
  ],
  tools: [{ name: 'Git', level: 5 }, { name: 'Docker', level: 3 }, { name: 'Yarn', level: 3 }],
};
